import { Component } from '@angular/core';

@Component({
  selector: 'app-blacklists-by-product',
  templateUrl: './blacklists-by-product.component.html',
  styleUrls: ['./blacklists-by-product.component.scss'],
})
export class BlacklistsByProductComponent {}
